<template>
  <Icon name="expand_more" class="w-[26px] h-[26px] flex-shrink-0 text-gray-500" />
</template>
